import { PROYECT, api_get, api_post, api_put } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { selectMessageStamp } from "helpers/messages";

const { cashInvoicesType } = require("redux/reducers/invoices/cashInvoicesType");

const {
  GET_NOTE_UNIFICATION,
  GET_BILLING_REASONS,
  ADD_NOTE,
  NOTES_RECALCULATE,
  REMOVE_NOTE,
  UPDATE_RESUME,
  RESTORE_STATE,
  DATA_SEND_MODE,
  SET_DATA_TO_SEND,
  GET_SERIES,
  CLEAR_SERIES_LIST,
  RESTORE_INITIAL,
  ERROR_GET_NOTE,
  CHANGE_REASON,
  UPDATE_DATE_NOTE,
  RESTART_FORM,
} = cashInvoicesType
const base = "loadingInvoices"
const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}`

export const addCashInvoiceNote = (note) => ({
  type: ADD_NOTE,
  payload: note
})

export const removeCashInvoiceNote = (id) => ({
  type: REMOVE_NOTE,
  payload: id
})

export const updateResume = () => ({
  type: UPDATE_RESUME,
})

export const restoreState = () => ({
  type: RESTORE_STATE,
})

export const changeReason = (reason) => ({
  type: CHANGE_REASON,
  payload: reason
})

export const getNoteUnification = (invoiceKey = "", folio = "") => {
  const url = `${mainUrl}/notes/unification-note?invoiceKey=${invoiceKey}&folio=${folio}`
  return async dispatch => {
    dispatch(startRequestComp(`${base}UnificationNote`))
    try {
      const response = await api_get(url)
      if (!response) return dispatch(setSnackbar("Error", "warning"))
      dispatch({
        type: GET_NOTE_UNIFICATION,
        payload: response
      })
    } catch (error) {
      dispatch({
        type: ERROR_GET_NOTE,
      })
      dispatch(setSnackbar(error))
    }
    dispatch(stopRequestComp(`${base}UnificationNote`))
  }
}

export const cleanNoteUnification = () => {
  return async dispatch => {
    dispatch({
      type: GET_NOTE_UNIFICATION,
      payload: {},
    })
  }
}

export const getBillingReasons = () => {
  const url = `${mainUrl}/billing-reasons`
  return async dispatch => {
    dispatch(startRequestComp(`${base}BillingReasons`))
    try {
      const response = await api_get(url)
      if (!response) return dispatch(setSnackbar("Error", "warning"))
      dispatch({
        type: GET_BILLING_REASONS,
        payload: response
      })
    } catch (error) {
      dispatch(setSnackbar(error))
    }
    dispatch(stopRequestComp(`${base}BillingReasons`))
  }
}

export const getInvoicesSeries = (stationsIds) => {
  const params = stationsIds.map((id) => `station=${id}`).join("&")
  const url = `${mainUrl}/series/factura?${params}`
  return async dispatch => {
    dispatch(startRequestComp(`${base}Series`))
    try {
      const response = await api_get(url)
      if (!response) return dispatch(setSnackbar("Error", "warning"))
      dispatch({
        type: GET_SERIES,
        payload: response?.series
      })
    } catch (error) {
      dispatch(setSnackbar(error))
    }
    dispatch(stopRequestComp(`${base}Series`))
  }
}

export const clearSeriesList = () => ({
  type: CLEAR_SERIES_LIST
})

export const prepareInvoiceData = (payload = false) => {
  return { type: DATA_SEND_MODE, payload }
}

export const setDataToSend = (key = "", data) => {
  return {
    type: SET_DATA_TO_SEND,
    payload: { key, data }
  }
}

export const sendCashInvoices = (form) => {
  const url = `${process.env.REACT_APP_URL_PAY}/invoices/unification-note?qid=${process.env.REACT_APP_QID_INVOICES}`
  return async dispatch => {
    dispatch(startRequestComp(`${base}SendData`))
    try {
      const response = await api_post(url, form)
      form.receiver?.receiverExists && dispatch(sendFiscalData(form.receiver.receiverExists));
      dispatch({ type: RESTORE_INITIAL })
      window.open(response?.pdfUrl, '_blank');
      window.open(response?.cfdiUrl, '_blank');
      dispatch(setSnackbar("Factura enviada al correo", "success"))
      dispatch(prepareInvoiceData(false))
      selectMessageStamp(
        response.processingSummary,
        (message, variant) => dispatch(setSnackbar({ message, variant }))
      );
    } catch (error) {
      dispatch(setSnackbar(error))
    }
    dispatch(stopRequestComp(`${base}SendData`))
  }
}

export const recalculateNotes = (payload) => {
  return {
    type: NOTES_RECALCULATE,
    payload
  }
}

export const restart = () => ({
  type: RESTART_FORM,
})

export const updateDate = (date) => ({
  type: UPDATE_DATE_NOTE,
  payload: date
})

export const sendFiscalData = (form) => {
  const url = `${mainUrl}/fiscal-customers`
  return async dispatch => {
    try {
      await api_put(url, form)
    } catch (error) {
      dispatch(setSnackbar(error))
    }
  }
}
